<template>
  <el-upload
    action=""
    list-type="picture-card"
    :file-list="stored"
    :on-change="fileChangeHandler"
    :auto-upload="false"
    :on-preview="download"
    ref="files"
  >
    <i class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
import fileModel from './file-model';

export default {
  name: 'app-image-upload',

  props: {
    stored: {
      type: Array,
      default: [],
    },
    formats: {
      type: Array,
      default() {
        return ['gif', 'jpg', 'jpeg', 'png', 'svg'];
      },
    },
    size: Number,
    max: Number,
  },

  computed: {
    data() {
      return this.$refs.files.uploadFiles;
    },
  },

  methods: {
    download(file) {
      window.open(file.url, '_blank');
    },

    fileChangeHandler(file, files) {
      return fileModel.changeHandler(
        file,
        files,
        this.max,
        this.size,
        this.formats,
      );
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/shared/file/image-upload.vue?3fdeb24c